import { MapTo } from '@adobe/aem-react-editable-components';
import BankProductHeader, { BankProductHeaderEditConfig } from './BankProductHeader';

export default MapTo('cob-corp-acquisition/components/creditonebank/bank-product-header')(BankProductHeader, BankProductHeaderEditConfig);